// extracted by mini-css-extract-plugin
module.exports = {"item":"Item--item--1pUiP","item__title":"Item--item__title--QykdA","item__subtitle":"Item--item__subtitle--1x5qN"};